<template>
  <v-btn
    elevation="1"
    rounded="0"
    :variant="parsedBtnClass.color ? 'flat' : 'text'"
    :class="parsedBtnClass.layoutClass"
    :color="parsedBtnClass.color || undefined"
    v-bind="$attrs"
  >
    <v-icon
      v-if="icon"
      size="small"
      :color="iconColor"
      :class="iconClass"
      class="mr-1"
    >{{ icon }}</v-icon>
    <span :class="labelClass">{{ label }}</span>
  </v-btn>
</template>

<script>
import { parseBtnClass, normalizeVuetifyColor } from '@/helpers/vuetifyColor';

export default {
  name: 'BaseSidebarBtn',

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: 'Cancel',
    },
    icon: {
      type: String,
      default: '',
    },
    btnClass: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
  },

  computed: {
    parsedBtnClass() {
      return parseBtnClass(normalizeVuetifyColor(this.btnClass));
    },

    labelClass() {
      if (!this.iconColor) {
        return '';
      }
      if (this.iconColor === 'white') {
        return 'text-white';
      }
      if (this.iconColor === 'grey') {
        return 'text-grey';
      }
      return `text-${this.iconColor}`;
    },
  },
};
</script>
